export const CREATE_QUESTIONAIRE_QUESTION = "CREATE_QUESTIONAIRE_QUESTION"
export const CREATE_QUESTIONAIRE_QUESTION_SUCCESSFUL =
  "CREATE_QUESTIONAIRE_QUESTION_SUCCESSFUL"
export const CREATE_QUESTIONAIRE_QUESTION_FAILED =
  "CREATE_QUESTIONAIRE_QUESTION_FAILED"
export const CREATE_QUESTIONAIRE_QUESTION_RESET =
  "CREATE_QUESTIONAIRE_QUESTION_RESET"
